import ACTIONS from '../../../store/actions';
import getPrettyError from '../../../utils/getPrettyError';
import getHost from '../../../utils/host';
export var logoutUser = function logoutUser() {
  return function (dispatch, getState) {
    var userToken = getState().auth.token;
    var logoutUrl = '/backend/token?accessToken=' + userToken;
    var requestAction = {
      url: logoutUrl,
      method: 'DELETE'
    };
    return dispatch({
      type: ACTIONS.USER_LOGOUT,
      request: requestAction
    }).then(function (loginUrl) {
      localStorage.removeItem('ECR.EOS.AccessToken');
      var ecrionServer = getHost();
      if (ecrionServer.endsWith('/')) ecrionServer = ecrionServer.substring(0, ecrionServer.length - 1);
      var currentUrl = window.location.href.toLowerCase().indexOf('security') === -1 ? window.location.href : null;
      var newUrl = '/';
      if (!ecrionServer) newUrl = "".concat(loginUrl.body, "#").concat(currentUrl);else newUrl = "".concat(ecrionServer).concat(loginUrl.body, "#").concat(currentUrl);
      window.location.href = newUrl;
      return dispatch({
        type: ACTIONS.USER_LOGOUT_RESOLVED,
        payload: {
          loginUrl: loginUrl
        }
      });
    }).catch(function (error) {
      return dispatch({
        type: ACTIONS.USER_LOGOUT_FAILED,
        payload: {
          error: error.message,
          text: getPrettyError(error)
        }
      });
    });
  };
};
export default logoutUser;